<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/qr.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg"
            >
              <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">Book a Ride</h4>
                    <p>Please enter details of your trip.</p>
                  </div>
                  <gmap-autocomplete
                    ref="autocomplete"
                    class="w-full vs-inputx vs-input--input normal"
                    @place_changed="setPlace"
                    label-placeholder="Destination"
                    placeholder="Destination"
                    name="destination"
                    v-validate="'required'"

                  ></gmap-autocomplete>
                  <span
                    v-show="errors.has('destination')"
                    class="text-danger"
                    >{{ errors.first("destination") }}</span
                  >

                  <br />
                  <br />
                  <vs-input
                    placeholder="Customer Name"
                    v-model="customer.name"
                    name="name"
                    class="w-full"
                  />
                  <br />
                  <vs-input
                    placeholder="Customer Phonenumber"
                    v-model="customer.telephone"
                    name="telephone"
                    class="w-full"
                  />
                  <br /><br />
                  <div
                    class="flex flex-wrap justify-between flex-col-reverse sm:flex-row"
                  >
                    <vs-button class="w-full sm:w-auto" @click.prevent="bookNow"
                     :disabled="!validateForm"  >Book Now</vs-button
                    >
                  </div>
                  <br><br>
                  <div>
                    <div class="mt-6" v-if="payment_link">
                      Payment Link is:
                      <a v-bind:href="payment_link">{{ payment_link }}</a>
                    <vs-divider position="center"><h5>Booking Details</h5></vs-divider>

                    <span class="mt-4 flex items-center"><h6>Pickup : </h6> &nbsp; {{source}}</span>
                    <span class="flex items-center"><h6>Destination : </h6> &nbsp; {{destination}}</span>
                    <span class="flex items-center"><h6>Booked at time : </h6> &nbsp; {{date_time}}</span>
                    <span class="flex items-center"><h6>Pickup due time : </h6> &nbsp; {{pickup_due_time}}</span>
                    <span class="flex items-center"><h6>Price : </h6> &nbsp; £ {{price}}</span>
                    </div>
                  </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import { _bookByQr } from "@/services/Booking.js";

const dict = {
  custom: {
    name: {
      required: "Customer name is required"
    },
    telephone: {
      required: "Customer number is required"
    }
  }
};
// register custom messages
Validator.localize("en", dict);
export default {
  data() {
    return {
      customer: {
        name: "",
        telephone: ""
      },

      payment_link: "",
      source: "",
      destination: "",
      date_time: "",
      price: "",

      pickup_due_time: null,


      destinationPlace: "",
      venueId: this.$route.params.venue_id
    };
  },
  computed: {
    validateForm() {
        return !this.errors.any() && this.destinationPlace != '';
    }
    },
  created() {
    this.$validator.extend("cust-telephone", {
      getMessage: field => "The " + field + " must start with 07",
      validate: value => {
        var strongRegex = new RegExp("^(07)([0-9]*)$");
        var val = strongRegex.test(value);
        if (this.payByCard == true) {
          if (val == true) {
            return true;
          }
          return false;
        }
        return true;
      }
    });
  },
  methods: {
    setPlace(place) {
      this.destinationPlace = place;
    },

    bookNow() {
         this.$vs.loading();
            let data = {
              venueId: this.venueId,
              customer: this.customer,
              pickupDueTime: new Date(),
              destination: {
                _text: this.destinationPlace
                  ? this.destinationPlace.formatted_address
                  : null,
                lat: this.destinationPlace
                  ? this.destinationPlace.geometry.location.lat()
                  : null,
                lng: this.destinationPlace
                  ? this.destinationPlace.geometry.location.lng()
                  : null,
                placeId: this.destinationPlace
                  ? this.destinationPlace.place_id
                  : null
              }
            };

            _bookByQr(this.venueId, data)
              .then(res => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: res.data.responseTitle,
                  text: res.data.responseMessage,
                  iconPack: "feather",
                  icon: "icon-check-circle",
                  color: "success"
                });
                this.customer.name = "";
                this.customer.telephone = "";
                this.destinationPlace = ""
                this.$refs.autocomplete.$refs.input.value = "";



                this.payment_link = res.data.obj.message;
            this.source = res.data.obj.pickup;
            this.destination = res.data.obj.destination;
            this.date_time = res.data.obj.date_time;
            this.pickup_due_time = res.data.obj.pickup_due_time;
            this.price = res.data.obj.price;

              })
              .catch(error => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: error.response.data.responseTitle,
                  text: error.response.data.responseMessage,
                  iconPack: "feather",
                  icon: "icon-cross-circle",
                  color: "danger"
                });
              });
    }
  }
};
</script>
